/* Product detail interactions.

   Two things: reveal the sticky bar once the buy column has scrolled past,
   and keep the sticky bar's figure in step with the selected variant.

   The buy form itself is a plain product form, so add-to-cart works without
   JavaScript. The sticky bar is progressive enhancement and stays hidden
   until scripting confirms it can be driven.
*/

(function () {
  'use strict';

  function init() {
    const root = document.querySelector('.dopa-product');
    const sticky = document.querySelector('[data-dopa-sticky]');
    if (!root || !sticky) return;

    const buy = root.querySelector('.dopa-product__buy');
    const atc = root.querySelector('.dopa-product__atc');
    if (!buy) return;

    // Reveal once the in-page add-to-cart has scrolled out of view.
    if ('IntersectionObserver' in window && atc) {
      sticky.hidden = true;
      const io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            sticky.hidden = entry.isIntersecting;
          });
        },
        { rootMargin: '0px 0px -80px 0px' }
      );
      io.observe(atc);
    } else {
      sticky.hidden = false;
    }

    // Keep the sticky figure in step with the chosen pack size.
    const figure = sticky.querySelector('.dopa-price__figure');
    if (!figure) return;
    root.querySelectorAll('input[name="id"]').forEach(function (input) {
      input.addEventListener('change', function () {
        const price = input.getAttribute('data-variant-price');
        if (price) figure.textContent = price;
      });
    });
  }

  function setupGallery() {
    const gallery = document.querySelector("[data-dopa-gallery]");
    if (!gallery) return;
    const frames = gallery.querySelectorAll(".dopa-gallery__frame");
    const thumbs = gallery.querySelectorAll(".dopa-gallery__thumb[data-slot]");
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        const slot = thumb.getAttribute("data-slot");
        // Cross-fade the plate. No zoom, no lightbox.
        frames.forEach(function (frame) {
          const active = frame.getAttribute("data-slot") === slot;
          frame.classList.toggle("is-active", active);
          if (active) frame.removeAttribute("aria-hidden");
          else frame.setAttribute("aria-hidden", "true");
        });
        thumbs.forEach(function (t) { t.classList.toggle("is-active", t === thumb); });
      });
    });
  }

  function setupQuantity() {
    const input = document.querySelector(".dopa-qty__input");
    if (!input) return;
    document.querySelectorAll("[data-dopa-qty]").forEach(function (button) {
      button.addEventListener("click", function () {
        const delta = parseInt(button.getAttribute("data-dopa-qty"), 10);
        const next = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
        input.value = next;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  }

  /* Inline clips never autoplay: the visitor chooses. The overlay button is
     the affordance; the native controls take over once it is playing. */
  function setupClips() {
    document.querySelectorAll("[data-dopa-product-video]").forEach(function (wrap) {
      const video = wrap.querySelector("video");
      const button = wrap.querySelector("[data-dopa-play]");
      if (!video || !button) return;
      button.addEventListener("click", function () {
        video.preload = "auto";
        const attempt = video.play();
        if (attempt && typeof attempt.catch === "function") attempt.catch(function () {});
        wrap.classList.add("is-playing");
      });
      video.addEventListener("pause", function () { wrap.classList.remove("is-playing"); });
      video.addEventListener("ended", function () { wrap.classList.remove("is-playing"); });
    });
  }

  function boot() { init(); setupGallery(); setupQuantity(); setupClips(); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

/*
 * The phone board's four accordions.
 *
 * The markup ships <details open>, so with JavaScript off nothing is hidden —
 * the page is what it has always been. Below 750px these four close, which is
 * how mobile-all-templates part 5 draws them; above it they stay open and
 * their summaries are hidden by CSS, so the desktop page does not change.
 *
 * Native <details>/<summary> carries the keyboard and screen-reader behaviour
 * on its own: the summary is focusable, Enter and Space toggle it, and the
 * open state is exposed without a line of ARIA. A visitor who has already
 * opened or closed one keeps their choice — the toggle marks the element and
 * a later resize leaves it alone.
 */
(function () {
  const phone = window.matchMedia('(max-width: 749px)');
  const rows = document.querySelectorAll('.dopa-acc');
  if (!rows.length) return;

  const apply = () => {
    rows.forEach(function (row) {
      if (row.dataset.dopaTouched === 'true') return;
      row.open = !phone.matches;
    });
  };

  rows.forEach(function (row) {
    row.addEventListener('toggle', function () {
      /* Only a real interaction counts, not the state we set ourselves. */
      if (row.dataset.dopaApplying !== 'true') row.dataset.dopaTouched = 'true';
    });
  });

  const run = () => {
    rows.forEach(function (r) { r.dataset.dopaApplying = 'true'; });
    apply();
    window.requestAnimationFrame(function () {
      rows.forEach(function (r) { delete r.dataset.dopaApplying; });
    });
  };

  run();
  phone.addEventListener('change', run);
})();
